module.exports = "<ng-template>\n    <div style=\"padding-top: 12px; padding-bottom: 10px;\">{{ (data)? model.getData(data) : '' }}</div>\n</ng-template>\n"